import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { IconButton } from '@mui/material';
import { ContentCopy } from '@mui/icons-material';
import CustomTooltip from '../../atoms/CustomTooltip';
import { useGeneralContext } from '../../../../context/GeneralContext';

const CopyCoordinatesIconButton = ({ lat, lng, className, placement }) => {
  const { t } = useTranslation();
  const { openToast } = useGeneralContext();
  const onCopy = () => {
    navigator.clipboard.writeText(`${lat.toFixed(4)}, ${lng.toFixed(4)}`);
    openToast(t('machines.facilities.center_pane.coordinates_copied'));
  };

  return (
    <CustomTooltip
      title={t('machines.facilities.center_pane.copy_coordinates')}
      placement={placement}
    >
      <IconButton
        color="inherit"
        size="small"
        onClick={onCopy}
        className={className}
      >
        <ContentCopy sx={className ? { color: 'white' } : null} />
      </IconButton>
    </CustomTooltip>
  );
};

CopyCoordinatesIconButton.propTypes = {
  lat: PropTypes.number.isRequired,
  lng: PropTypes.number.isRequired,
  className: PropTypes.string,
  placement: PropTypes.string,
};

export default CopyCoordinatesIconButton;
